import ImageCollectionPage from "../components/ImageCollectionPage";

export default function TribalMarks() {
  return <ImageCollectionPage title="Tribal Marks" path="/culture/tribal-marks" collection="culture_tribal_marks" />;
}
